import { render } from "./MythicPlusView.vue?vue&type=template&id=063f4a11"
import script from "./MythicPlusView.vue?vue&type=script&lang=js"
export * from "./MythicPlusView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__